// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "dashboard/v1/dashboard.proto" (package "dashboard.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal APIs for the n-machines dashboard service
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DashboardService } from "./dashboard";
import type { UpdateDashboardNameResponse } from "./dashboard";
import type { UpdateDashboardNameRequest } from "./dashboard";
import type { UpdateDashboardLayoutResponse } from "./dashboard";
import type { UpdateDashboardLayoutRequest } from "./dashboard";
import type { DeleteDashboardResponse } from "./dashboard";
import type { DeleteDashboardRequest } from "./dashboard";
import type { DuplicateDashboardResponse } from "./dashboard";
import type { DuplicateDashboardRequest } from "./dashboard";
import type { ListDashboardsResponse } from "./dashboard";
import type { ListDashboardsRequest } from "./dashboard";
import type { GetDashboardResponse } from "./dashboard";
import type { GetDashboardRequest } from "./dashboard";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateDashboardResponse } from "./dashboard";
import type { CreateDashboardRequest } from "./dashboard";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service dashboard.v1.DashboardService
 */
export interface IDashboardServiceClient {
    /**
     * @generated from protobuf rpc: CreateDashboard(dashboard.v1.CreateDashboardRequest) returns (dashboard.v1.CreateDashboardResponse);
     */
    createDashboard(input: CreateDashboardRequest, options?: RpcOptions): UnaryCall<CreateDashboardRequest, CreateDashboardResponse>;
    /**
     * @generated from protobuf rpc: GetDashboard(dashboard.v1.GetDashboardRequest) returns (dashboard.v1.GetDashboardResponse);
     */
    getDashboard(input: GetDashboardRequest, options?: RpcOptions): UnaryCall<GetDashboardRequest, GetDashboardResponse>;
    /**
     * @generated from protobuf rpc: ListDashboards(dashboard.v1.ListDashboardsRequest) returns (dashboard.v1.ListDashboardsResponse);
     */
    listDashboards(input: ListDashboardsRequest, options?: RpcOptions): UnaryCall<ListDashboardsRequest, ListDashboardsResponse>;
    /**
     * @generated from protobuf rpc: DuplicateDashboard(dashboard.v1.DuplicateDashboardRequest) returns (dashboard.v1.DuplicateDashboardResponse);
     */
    duplicateDashboard(input: DuplicateDashboardRequest, options?: RpcOptions): UnaryCall<DuplicateDashboardRequest, DuplicateDashboardResponse>;
    /**
     * @generated from protobuf rpc: DeleteDashboard(dashboard.v1.DeleteDashboardRequest) returns (dashboard.v1.DeleteDashboardResponse);
     */
    deleteDashboard(input: DeleteDashboardRequest, options?: RpcOptions): UnaryCall<DeleteDashboardRequest, DeleteDashboardResponse>;
    /**
     * @generated from protobuf rpc: UpdateDashboardLayout(dashboard.v1.UpdateDashboardLayoutRequest) returns (dashboard.v1.UpdateDashboardLayoutResponse);
     */
    updateDashboardLayout(input: UpdateDashboardLayoutRequest, options?: RpcOptions): UnaryCall<UpdateDashboardLayoutRequest, UpdateDashboardLayoutResponse>;
    /**
     * @generated from protobuf rpc: UpdateDashboardName(dashboard.v1.UpdateDashboardNameRequest) returns (dashboard.v1.UpdateDashboardNameResponse);
     */
    updateDashboardName(input: UpdateDashboardNameRequest, options?: RpcOptions): UnaryCall<UpdateDashboardNameRequest, UpdateDashboardNameResponse>;
}
/**
 * @generated from protobuf service dashboard.v1.DashboardService
 */
export class DashboardServiceClient implements IDashboardServiceClient, ServiceInfo {
    typeName = DashboardService.typeName;
    methods = DashboardService.methods;
    options = DashboardService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateDashboard(dashboard.v1.CreateDashboardRequest) returns (dashboard.v1.CreateDashboardResponse);
     */
    createDashboard(input: CreateDashboardRequest, options?: RpcOptions): UnaryCall<CreateDashboardRequest, CreateDashboardResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateDashboardRequest, CreateDashboardResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDashboard(dashboard.v1.GetDashboardRequest) returns (dashboard.v1.GetDashboardResponse);
     */
    getDashboard(input: GetDashboardRequest, options?: RpcOptions): UnaryCall<GetDashboardRequest, GetDashboardResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDashboardRequest, GetDashboardResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListDashboards(dashboard.v1.ListDashboardsRequest) returns (dashboard.v1.ListDashboardsResponse);
     */
    listDashboards(input: ListDashboardsRequest, options?: RpcOptions): UnaryCall<ListDashboardsRequest, ListDashboardsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDashboardsRequest, ListDashboardsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DuplicateDashboard(dashboard.v1.DuplicateDashboardRequest) returns (dashboard.v1.DuplicateDashboardResponse);
     */
    duplicateDashboard(input: DuplicateDashboardRequest, options?: RpcOptions): UnaryCall<DuplicateDashboardRequest, DuplicateDashboardResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DuplicateDashboardRequest, DuplicateDashboardResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteDashboard(dashboard.v1.DeleteDashboardRequest) returns (dashboard.v1.DeleteDashboardResponse);
     */
    deleteDashboard(input: DeleteDashboardRequest, options?: RpcOptions): UnaryCall<DeleteDashboardRequest, DeleteDashboardResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteDashboardRequest, DeleteDashboardResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDashboardLayout(dashboard.v1.UpdateDashboardLayoutRequest) returns (dashboard.v1.UpdateDashboardLayoutResponse);
     */
    updateDashboardLayout(input: UpdateDashboardLayoutRequest, options?: RpcOptions): UnaryCall<UpdateDashboardLayoutRequest, UpdateDashboardLayoutResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDashboardLayoutRequest, UpdateDashboardLayoutResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDashboardName(dashboard.v1.UpdateDashboardNameRequest) returns (dashboard.v1.UpdateDashboardNameResponse);
     */
    updateDashboardName(input: UpdateDashboardNameRequest, options?: RpcOptions): UnaryCall<UpdateDashboardNameRequest, UpdateDashboardNameResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDashboardNameRequest, UpdateDashboardNameResponse>("unary", this._transport, method, opt, input);
    }
}
